<template>
  <div>
     <v-data-table-virtual
        :headers="headers"
        :items="items"
      >
        <template v-slot:item.name="{ item }">
            <router-link :to="'/menu-categories/' + item.props.title.id + '/edit'">{{ item.props.title.name }}</router-link>
        </template>
      </v-data-table-virtual>
      
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const MenuCategoryRepository = RepositoryFactory.get("menuCategory");
export default {
    data() {
        return {
            items: [],
            headers: [
                {
                    title: "Название меню",
                    align: "start",
                    sortable: false,
                    key: "name",
                },
            ],
        }
    },
    mounted(){
        this.list();
    },
    methods:{
        async list() {
            const result = await MenuCategoryRepository.list();
                if (result.data.status === "success") {
                    this.items = result.data.data;
                    console.log(this.items);
                }
            }
        }
    }

</script>
